import {BooleanFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';

export const handleBooleanFilter = ({
  slug,
  isCurrentlyActive,
  setFilter,
  resetFilter,
}: {
  slug: string;
  isCurrentlyActive: boolean;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  resetFilter: (slug: string) => void;
}) => {
  if (isCurrentlyActive) {
    resetFilter(slug);
  } else {
    setFilter({
      filterId: 'true',
      filterSection: slug,
    });
  }
};

export const getBooleanFilterData = ({
  activeFilters,
  filter,
}: {
  activeFilters: Map<string, Array<string> | undefined>;
  filter?: BooleanFilterSection;
}) => {
  if (!filter) {
    return {
      active: false,
      label: undefined,
      slug: undefined,
    };
  }

  const label = filter.label;
  const slug = filter.slug;
  const value = activeFilters.get(slug);
  const active = Boolean(value?.[0] && value[0] === 'true');

  return {
    active,
    label,
    slug,
  };
};
